<template>
    <div v-if="!!rating.count" class="d-flex justify-content-center align-items-center gap-2">
        <i class="bi bi-star-fill text-warning fs-4" />
        <p class="lh-1 mb-0 text-dark">
            <span class="fw-bold text-primary">
                {{ `${rating.average_score.toFixed(2)} / ${maxRating}` }} 
            </span>
            {{ `(${ratingCountString})` }}
        </p>
    </div>
    <span v-else class="text-muted">{{ $translate('no_reviews', 'Inga omdömen') }}</span>
</template>

<script>
export default {
    props: {
        rating: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            maxRating: 5
        };
    },
    computed: {
        ratingCountString() {
            return this.$translate('reviews_count', '{count} omdömen').replace('{count}', this.rating.count);
        }
    }
};
</script>